/**
 * Maps the hotel static `badges` types (as returned by the hotel static endpoint,
 * e.g. "FAMILY_HOTEL", "BEACH_HOTEL") to their full translation key.
 *
 * Using full keys (instead of building them from a lowercased type) avoids the
 * mismatches where the type stem differs from the copy key — e.g. HIGHWAY_HOTEL
 * maps to `...badgets.motel`.
 */
export const HERO_BADGE_TRANSLATION_KEYS: Record<string, string> = {
  AIRPORT_HOTEL: 'vacation.oss.cards.badgets.airporthotel',
  BEACH_HOTEL: 'vacation.oss.cards.badgets.beachhotel',
  BOUTIQUE_HOTEL: 'vacation.oss.cards.badgets.boutiquehotel',
  BUSINESS_HOTEL: 'vacation.oss.cards.badgets.businesshotel',
  CASINO_HOTEL: 'vacation.oss.cards.badgets.casinohotel',
  CITY_HOTEL: 'vacation.oss.cards.badgets.cityhotel',
  ECONOMIC_HOTEL: 'vacation.oss.cards.badgets.economichotel',
  FAMILY_HOTEL: 'vacation.oss.cards.badgets.familyhotel',
  GOLF_HOTEL: 'vacation.oss.cards.badgets.golfhotel',
  HIGHWAY_HOTEL: 'vacation.oss.cards.badgets.motel',
  LAKE_HOTEL: 'vacation.oss.cards.badgets.lakehotel',
  LUXURY_HOTEL: 'vacation.oss.cards.badgets.luxuryhotel',
  RESORT_HOTEL: 'vacation.oss.cards.badgets.resorthotel',
  ROMANTIC_HOTEL: 'vacation.oss.cards.badgets.romantichotel',
  WATERPARK_HOTEL: 'vacation.oss.cards.badgets.waterparkhotel',
  WELLNESS_HOTEL: 'vacation.oss.cards.badgets.wellnesshotel',
  WINTERSPORTS_HOTEL: 'vacation.oss.cards.badgets.wintersportshotel',
};
